import HttpClient from "../../../utils/HttpClient";

const sendSmsSingle = (aPhoneNumber, aMessage) => {
  return HttpClient.HttpClientWebApi().post('/Communication/SendSmsSingle', {message: aMessage, phoneNumber: aPhoneNumber });
}

export default {
  sendSmsSingle,
}
